import { endPoints, requestType } from "../../constants/Variables";
import Api from "../index";

const createCompanyUser = (params) => {
  return Api(endPoints.createCompanyUser, params, requestType.POST);
};

const getAllCompanyUser = (id) => {
  return Api(`${endPoints.getAllCompanyUser}/${id}`, null, requestType.GET);
};

const updateCompanyUser = (id, params) => {
  return Api(`${endPoints.updateCompanyUser}/${id}`, params, requestType.PUT);
};

const deleteCompanyUser = (id) => {
  return Api(`${endPoints.deleteCompanyUser}/${id}`, null, requestType.DELETE);
};

export {
  createCompanyUser,
  getAllCompanyUser,
  updateCompanyUser,
  deleteCompanyUser,
};
